// src/pages/ContactPage.js

import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';

function ContactPage() {
  // State to store form input
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  // Optional: track submission status for user feedback
  const [status, setStatus] = useState('');

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page refresh
    setStatus('Sending...');

    try {
      // Make a POST request to your backend endpoint
      const response = await fetch('https://benignfasciculationsyndrome.org/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
        }),
      });

      if (response.ok) {
        setStatus('Your message has been sent successfully!');
        // Clear the form
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus('There was a problem sending your message. Please try again.');
      }
    } catch (error) {
      console.error(error);
      setStatus('There was a problem sending your message. Please try again.');
    }
  };

  return (
    <>
      {/* ------------------------------------------
          Inline Style to Force Montserrat Globally
          (Remove if using a global CSS file)
      ------------------------------------------- */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');

          body, h1, h2, h3, h4, h5, h6, p, .btn, .navbar-brand, .nav-link, label {
            font-family: 'Montserrat', sans-serif !important;
          }
        `}
      </style>

      {/* ========== CONTACT PAGE HERO SECTION ========== */}
      <div
        style={{
          backgroundColor: '#003f5c',
          color: '#fff',
          padding: '6rem 0',
          textAlign: 'center',
        }}
      >
        <Container>
          <h1 style={{ fontWeight: '700', fontSize: '2.5rem' }}>Contact Us</h1>
          <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '1rem auto' }}>
            We’re here to help—reach out with questions, suggestions, or for more information about BFS.
          </p>
        </Container>
      </div>

      {/* ========== CONTACT FORM & INFO SECTION ========== */}
      <div style={{ backgroundColor: '#f5f5f5', padding: '4rem 0' }}>
        <Container>
          <Row className="align-items-start">
            {/* Contact Form */}
            <Col md={6} className="mb-4 mb-md-0">
              <h2 style={{ fontWeight: '700', marginBottom: '1rem', fontSize: '1.8rem' }}>
                Send Us a Message
              </h2>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="contactName">
                  <Form.Label>Your Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="contactEmail">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="contactMessage">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    name="message"
                    placeholder="How can we help you?"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Button variant="danger" type="submit" className="fw-semibold rounded-pill">
                  Submit
                </Button>
              </Form>
              {/* Display submission status */}
              {status && <p style={{ marginTop: '1rem' }}>{status}</p>}
            </Col>

            {/* Contact Info */}
            <Col md={6}>
              <h2 style={{ fontWeight: '700', marginBottom: '1rem', fontSize: '1.8rem' }}>
                Other Ways to Reach Us
              </h2>
              <p style={{ fontSize: '1.1rem' }}>
                <strong>Email:</strong> info@BenignFasciculationSyndrome.org
              </p>
              <p style={{ fontSize: '1.1rem' }}>
                Whether you have questions about Benign Fasciculation Syndrome, want to 
                discuss volunteer opportunities, or are looking to donate, we’re always happy 
                to connect. We’ll do our best to respond promptly to all inquiries.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default ContactPage;
